import { render, staticRenderFns } from "./VideoSync.vue?vue&type=template&id=892d7fe0&scoped=true&"
import script from "./VideoSync.vue?vue&type=script&lang=ts&"
export * from "./VideoSync.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSync.vue?vue&type=style&index=0&id=892d7fe0&lang=scss&scoped=true&"
import style1 from "./VideoSync.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d7fe0",
  null
  
)

export default component.exports